// ConnectionContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const ConnectionContext = createContext();

export const ConnectionProvider = ({ children }) => {
  const [connections, setConnections] = useState(() => {
    // Load from sessionStorage on initial load
    const saved = sessionStorage.getItem('user_connections');
    return saved ? JSON.parse(saved) : {};
  });

  // Save to sessionStorage whenever connections change
  useEffect(() => {
    sessionStorage.setItem('user_connections', JSON.stringify(connections));
  }, [connections]);

  const updateConnection = (id, status) => {
    setConnections(prev => ({
      ...prev,
      [id]: status
    }));
  };

  // Clear specific connection (optional)
  const clearConnection = (id) => {
    setConnections(prev => {
      const newConnections = { ...prev };
      delete newConnections[id];
      return newConnections;
    });
  };

  return (
    <ConnectionContext.Provider value={{ 
      connections, 
      updateConnection, 
      clearConnection 
    }}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useConnection = () => useContext(ConnectionContext);